import React, { useState } from 'react'
import AWS from "aws-sdk";
import responseHandler from '../../utils/notifications/responseHandler';

const TestUpload = () => {
  // Create state to store file
  const [file, setFile] = useState(null);
  // Function to upload file to s3
  const uploadFile = async () => {
      if (!file) return 
    //   responseHandler({},"Uploaded")
    // S3 Bucket Name
    const S3_BUCKET = process.env.ReactREACT_APP_WHISPA_S3_BUCKET;

    // S3 Region
    const REGION = "region";

    // S3 Credentials
    AWS.config.update({
      accessKeyId: process.env.REACT_APP_WHISPA_AWS_ID,
      secretAccessKey: process.env.REACT_APP_WHISPA_SECRET_KEY,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    // Files Parameters

    const params = {
      Bucket: S3_BUCKET,
      Key: file.name,
      Body: file,
    };

    // Uploading file to s3

    var upload = s3
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        // File uploading progress
        console.log(
          "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%"
        );
      })
      .promise();

    await upload.then((err, data) => {
      console.log(err);
      // Fille successfully uploaded
      alert("File uploaded successfully.");
    });
  };
  // Function to handle file and store it to file state
  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };
  return (
    <div className="App">
      <div>
        <input type="file" onChange={handleFileChange} />
        <button onClick={uploadFile}>Upload</button>
      </div>
    </div>
  );
}

export default TestUpload